// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BasicEnrollmentResponse } from './basicEnrollmentResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IEditedEnrollmentResponse {
    'originalEnrollmentId': number;
    'editedEnrollment': BasicEnrollmentResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IEditedEnrollmentResponse>> = [
        {
            "name":     "originalEnrollmentId",
            "baseName": "originalEnrollmentId",
            "type":     "number"
        },
        {
            "name":     "editedEnrollment",
            "baseName": "editedEnrollment",
            "type":     "BasicEnrollmentResponse"
        },
    ];

    static getAttributeTypeMap() {
        return IEditedEnrollmentResponse.attributeTypeMap;
    }
}
